import { useTranslateTime } from "@kaltura/mediaspace-shared-utils";
import { useConfig } from "@kaltura/mediaspace-shared-data-kms-config";

interface DateCellProps {
    timestamp: number;
}

/**
 * Media table cell contents with a formatted date, e.g. "created at"
 */
export const DateCell = ({ timestamp }: DateCellProps) => {
    const config = useConfig();
    const formattedTimestamp = useTranslateTime(timestamp, config.application.dateFormats.shortDate);

    return <span>{formattedTimestamp}</span>;
};
